import React, { useState } from "react";
import { Button, Offcanvas } from "react-bootstrap";
import { Link } from "react-router-dom";
import algoquantLogo from "../../Assets/Images/algoquant_logo.jpg";

function SideNavLoad({ name, ...props }) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <Button onClick={handleShow} className="me-2 sideMenuIcon">
        <i className="fas fa-bars"></i>
      </Button>
      <Offcanvas show={show} onHide={handleClose} {...props}>
        <Offcanvas.Header closeButton>
          <Link className="navbar-brand" to="/" onClick={handleClose}>
            <img
              className="brand"
              src={algoquantLogo}
              alt="Algoquant Global Logo"
              title="Algoquant Global"
              width="100px"
              style={{ padding: "10px 20px" }}
            />
          </Link>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <ul className="navLinksStyle">
            <li className="list">
              <a href="http://ipo.algoquant.global:7000/">IPO</a>
            </li>
            <li className="list">
              <a href="http://rms.algoquant.global:8888/WEBR">RMS</a>
            </li>
            <li className="list">
              <Link to="/" onClick={handleClose}>
                About
              </Link>
            </li>
            <li className="list">
              <Link to="/contact" onClick={handleClose}>
                Contact
              </Link>
            </li>
            <li className="list">
              <a href="https://122.160.40.174:10443/">Backoffice</a>
            </li>
            <li className="list">
              <Link to="/download" onClick={handleClose}>
                Downloads
              </Link>
            </li>
            {/* <li className="list">
              <a href="http://oats.algoquant.global:3000/#/app">OATS</a>
            </li> */}
          </ul>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default SideNavLoad;
